import * as Yup from "yup";

const FAQSchema = Yup.object().shape({
	question: Yup.string().required("Required"),
	answer: Yup.string().required("Required"),
});

export default FAQSchema;